module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"likeyouthDescription":"Like Youth è un’applicazione interattiva che ti permette di scoprire quanto i tuoi like su Facebook corrispondono ai tuoi interessi.","textLogin":"Accedi con Facebook","textLoginLoading":"Accesso in corso...","textShare":"Condividi su Facebook"},"en":{"likeyouthDescription":"Like Youth è un’applicazione interattiva che ti permette di scoprire quanto i tuoi like su Facebook corrispondono ai tuoi interessi.","textLogin":"Login with Facebook","textLoginLoading":"Logging in...","textShare":"Share on Facebook"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/app/signup/survey-landing.vue
// module id = 102
// module chunks = 0